import React from "react";

export interface CardHeaderProps {
  /**
   * Content inside the card header, can be text or JSX elements.
   */
  children: React.ReactNode;
  /**
   * Allow handling click events for collapsing
   */
  onClick?: () => void;
  /**
   * Optional prop for dropdown icon alignment
   */
  hasDropdown?: boolean;
  /** Content to display on the right side (e.g., button, tag, collapse icon). */
  rightContent?: React.ReactNode;
}

/**
 * The header section of the card, which usually contains the title or any important action.
 */
export const CardHeader: React.FC<CardHeaderProps> = ({ children, onClick, hasDropdown = false, rightContent,
}) => {
  return (
    <div
      className={`px-4 py-3 border-b border-semantic-border-secondary flex items-center justify-between  ${
        hasDropdown ? "cursor-pointer" : ""
      }`}
      onClick={onClick}
    >
       <div className="flex-1">{children}</div>
      {/* {children} */}
      {rightContent && <div className="flex items-center space-x-2">{rightContent}</div>}

    </div>
  );
};

export default CardHeader;
